import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Card,
  Chip,
  Container,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Tables from '../../../components/Tables';
import PageTitleWrapper from '../../../components/PageTitleWrapper';
import PageHeader from '../../../components/pageHeader';
import NoDataFound from '../../../components/NoDataFound';
import CommonDialog from '../../../utils/commenModel';
import { useTranslation } from 'react-i18next';
import FormInputPage from 'src/components/FormFields/PageInput';
import DeleteAccount from '../auth/deleteAccount';
import { useGetClientListQuery, } from 'src/reduxServer/services/client';
import Loader from 'src/components/Loader';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Clients = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
   const [search, setSearch] = useState('');
  const [searchType, setSearchType] = useState('all');

  const { data, isLoading } = useGetClientListQuery({
    search: search,
    search_by: searchType,
  });




  /* 🔍 FILTER LOGIC */
  const filteredClients = useMemo(() => {
    if (!data?.results) return [];

    return data.results.map((item) => ({
      id: item.id,
      name: `${item.first_name} ${item.last_name}`,
      email: item.email,
      mobile: item.mobile,
      gender: item.gender === "M" ? "Male" : "Female",
      status: item.is_active === true ? "Active" : "Inactive",
    }));

  }, [data, searchType]);

  useEffect(() => {
    if (searchType === 'all') {
      setSearch('')
    }
  }, [searchType])

  const totalCount = filteredClients.length;

 

  const handleClientDetails = (item) => {
    navigate(`/Page/client-datail/${item?.id}`)
  }

  const columns = [
    {
      key: 'name', label: t('Name'),
      render: (row: any) => (
        <span
          style={{
            color: '#1976d2',
            cursor: 'pointer'
          }}
          onClick={() => handleClientDetails(row)}
        >
          {row.name}
        </span>
      )
    },
    { key: 'email', label: t('Email') },
    { key: 'mobile', label: t('MobileNumber') },
    {
      key: 'status',
      label: t('Status'),
      render: (row: any) => (
        <Chip
          label={row.status === 'Active' ? t('Active') : t('Deactive')}
          color={row.status === 'Active' ? 'success' : 'error'}
          size="small"
        />
      )
    },

  ];

  const selectValues = [
    { label: t('all'), value: 'all' },
    { label: t('Name'), value: 'name' },
    { label: t('Email'), value: 'email' },
    { label: t('MobileNumber'), value: 'mobile' }
  ]

  if (isLoading) {
    return <Loader />
  }

  return (
    <>

            <Helmet>
                    <title>Clients</title>
                  </Helmet>
      <PageTitleWrapper>
        <Container maxWidth="xl">
          <Grid container alignItems="center" spacing={2}>
            <Grid item xs={12} md={4}>
              <PageHeader title={t('Clients')} />
            </Grid>

            <Grid item xs={12} md={8}>
              <Stack direction="row" spacing={1} justifyContent="flex-end">
                <Box sx={{ minWidth: 120,marginLeft:"10px" }}>
                  <FormInputPage
                    select
                    value={searchType}
                    onChange={setSearchType}
                    options={selectValues}
                  />
                </Box>

                <TextField
                  label={t('Search')}
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </PageTitleWrapper>

      <Container maxWidth="xl">
        <Card sx={{ minHeight: 500 }}>
          {filteredClients.length === 0 ? (
            <Box display="flex" justifyContent="center" p={5}>
              <NoDataFound />
            </Box>
          ) : (
            <Tables
              columns={columns}
              data={filteredClients}
              total={totalCount}
              page={page}
              limit={limit}
              onPageChange={(_, newPage) => setPage(newPage)}
              onLimitChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(0);
              }}
            />
          )}
        </Card>
      </Container>

    </>
  );
};

export default Clients;
